import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { CONSTANT, ModalService, AdobeService, ADOBE_TAGS } from '@sm360/widget-commons-general';

import { SIGN_UP, LOGIN } from 'login/constants/modalNames.js';

import 'login/components/SignIn/Links/SignUpLink.scss';

class SignUpLink extends React.Component {
    constructor(props) {
        super(props);

        this.signinModal = ModalService.get(LOGIN);
        this.signupModal = ModalService.get(SIGN_UP);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        this.signupModal.addOnCloseCallbackFromAnotherModal(this.signinModal);
        this.signupModal.open();
        this.signinModal.close(true);

        if (this.props.hasAdobeTagging) {
            AdobeService.eventTrigger(ADOBE_TAGS.LOGIN_CTA(CONSTANT.ACCOUNT.CREATE), 'global-onclick');
        }
    }

    render() {
        return (
            <div className="createAccount">
                {LocaleService.t('LOGIN.NO_ACCOUNT')}
                <button
                    onClick={this.handleClick}
                    className="sr-link"
                    data-test="login.sign-in.sign-up-redirection-button"
                >
                    {LocaleService.t('LOGIN.SIGN_UP')}
                </button>
            </div>
        );
    }
}

SignUpLink.propTypes = {
    hasAdobeTagging: PropTypes.bool,
};

SignUpLink.defaultProps = {
    hasAdobeTagging: false,
};

SignUpLink.displayName = 'SignUpLink';

export default SignUpLink;
